import { API_URL } from "@/config/constants";
import axios from "axios";
import type { IChecklistGenerationRequest } from "./checklist-generation.types";

const API = `${API_URL}/clause-checklists`;

export const generateChecklist = async (
    request: IChecklistGenerationRequest,
    signal?: AbortSignal
): Promise<ReadableStream<Uint8Array>> => {
    const response = await axios.post<ReadableStream<Uint8Array>>(
        `${API}/generate`,
        request,
        {
            responseType: "stream",
            adapter: "fetch",
            signal,
        }
    );

    return response.data;
};

export const refineChecklist = async (
    draftId: number,
    refinementPrompt: string,
    signal?: AbortSignal
) => {
    const response = await axios.post(
        `${API}/drafts/${draftId}/refine`,
        { refinement_prompt: refinementPrompt },
        {
            responseType: "stream",
            adapter: "fetch",
            signal,
        }
    );

    return response.data;
};
